import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 400,
  },
});

function createData(years, pentads, cards, species) {
  return { years, pentads, cards, species };
}

const rows = [
  createData('All years', 5343, 10623, 921),
  createData('2023', 812, 1248, 705),
  createData('2022', 513, 733, 607),
  createData('2021', 1033, 1515, 729),
  createData('2020', 814, 1323, 700),
  createData('2019', 839, 1359, 714),
  createData('2018', 831, 1296, 698),
  createData('2017', 541, 744, 634),
  createData('2016', 331, 429, 572),
  createData('2015', 7, 7, 203),
];

export default function BasicTable() {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Years</TableCell>
            <TableCell align="right">Pentads</TableCell>
            <TableCell align="right">Cards</TableCell>
            <TableCell align="right">Species</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.years} >
              <TableCell component="th" scope="row">
                {row.years}
              </TableCell>
              <TableCell align="right">{row.pentads}</TableCell>
              <TableCell align="right">{row.cards}</TableCell>
              <TableCell align="right">{row.species}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
